import { List } from "lucide-react";
import type { TocEntry } from "@/lib/agora/article-toc";

/**
 * Sommaire d'une analyse publiée. Rendu côté serveur (donc indexable) et
 * purement ancré : aucun JavaScript n'est nécessaire pour naviguer.
 */
export default function ArticleToc({ entries }: { entries: TocEntry[] }) {
  if (entries.length < 2) return null;

  return (
    <nav
      aria-labelledby="sommaire-analyse"
      className="mt-8 rounded-xl border border-border bg-muted/30 p-4"
    >
      <h2
        id="sommaire-analyse"
        className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-muted-foreground"
      >
        <List className="h-4 w-4" aria-hidden />
        Sommaire
      </h2>
      <ol className="mt-3 space-y-1 text-sm">
        {entries.map((entry) => (
          <li key={entry.id} className={entry.level === 3 ? "ml-4" : undefined}>
            <a
              href={`#${entry.id}`}
              className="inline-flex min-h-11 items-center rounded text-muted-foreground transition-colors hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:min-h-0"
            >
              {entry.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
